// @NOTE: assumes jQuery is included by WP
const $ = jQuery
import 'chosen-js';

class projects {
  constructor () {
    this.$location            = $("#location")
    this.$projectsType        = $("#projects_type")
    this.projectList          = $(".project-list")
    this.$locationselect      = $('.location-select')
    this.$projtypeselect      = $('.projtype-select')
    this.$window              = $(window)
    this.onWindowResize()
    setTimeout(() => {
      bodySpacing()
    }, 1000)

    // custom select

    const select = document.querySelectorAll('.selectBtn');
    const option = document.querySelectorAll('.option');
    let index = 1;

    select.forEach(a => {
      a.addEventListener('click', b => {
        b.target.classList.add('active');
        const next = b.target.nextElementSibling;
        if (next.classList.contains('locationDropdown')) {
          $('.selectDropdown.projectDropdown').removeClass('toggle');
        }
        else {
          $('.selectDropdown.locationDropdown').removeClass('toggle');
        }
        next.classList.toggle('toggle');
        next.style.zIndex = index++;
      })
    })
    option.forEach(a => {
      a.addEventListener('click', b => {
        b.target.parentElement.classList.remove('toggle');
        
        const parent = b.target.closest('.select').children[0];
        parent.setAttribute('data-type', b.target.getAttribute('data-type'));
        parent.innerText = b.target.innerText;
      })
    })

    $(".locationDropdown .option").on('click', function(){
      $('#location .selectBtn').removeClass('active');
      $('#location .option').removeClass('active');
      $(this).addClass('active');
      getProjects()
    });

    $(".projectDropdown .option").on('click', function(){
      $('#projects_type .selectBtn').removeClass('active');
      $('#projects_type .option').removeClass('active');
      $(this).addClass('active');
      getProjects()
    });

    function bodySpacing () {
      var footerHeight = $('.site-footer').outerHeight();
      var headerHeight = 130;
      if (Number(window.width) < 768) {
        headerHeight = 80;
      }
      var titlesectionHeight = $('.post-title-filter-section').outerHeight();
      var totalHeight = headerHeight + footerHeight + titlesectionHeight;
      var windowHeight = $(window).innerHeight();
      var actualHeight = Number(windowHeight) - Number(totalHeight);
      $('.project-listing').css('min-height', actualHeight);
    }

    function getProjects() {
      let location = $('#location .selectBtn').attr('data-type');
      let project = $('#projects_type .selectBtn').attr('data-type');
      const ajaxUrl = window.ajaxUrl;
      const pageId = $('#project_page_id').val();

      // Update URL with query string parameters
      const urlParams = new URLSearchParams();

      // Add 'location' parameter to URL if selected
      if (location) {
        urlParams.set('location', location);
      }

      // Add 'project' parameter to URL if selected
      if (project) {
        urlParams.set('projecttype', project);
      }

      // Get the new URL without the '?' if no query parameters are present
      let newUrl = window.location.pathname;
      if (urlParams.toString()) {
        newUrl += '?' + urlParams.toString();
      }

      history.pushState(null, null, newUrl);

      // Update the select dropdowns with the selected values
      $('#location .selectBtn').text(location ? location : 'All Locations');
      $('#projects_type .selectBtn').text(project ? project : 'All Projects');

       // Get the selected location option text and update the dropdown accordingly
      if (location) {
        const locationOptionText = $('#location .selectDropdown .option[data-type="' + location + '"]').text();
        $('#location .selectBtn').text(locationOptionText);
      } else {
        $('#location .selectBtn').text('All Locations');
      }

      // Get the selected project type option text and update the dropdown accordingly
      if (project) {
        const projectOptionText = $('#projects_type .selectDropdown .option[data-type="' + project + '"]').text();
        $('#projects_type .selectBtn').text(projectOptionText);
      } else {
        $('#projects_type .selectBtn').text('All Projects');
      }

      $.ajax({
        type: 'POST',
        url: ajaxUrl,
        data: {
          action: 'show_project_lists_ajax',
          location: location,
          project: project,
          page_id: pageId,
        },
        beforeSend: () => {
          $('.post-loader').show();
        },
        success: (response) => {
          $('.post-loader').hide();
          $(".project-list").html(response.list.html);
          setTimeout(() => {
            bodySpacing();
          }, 4000);
        },
        error: (response) => {
          // Handle error if needed
        }
      });
    }

  } 

  bodySpacing () {
    var footerHeight = $('.site-footer').outerHeight();
    var headerHeight = 130;
    if (Number(window.width) < 768) {
      headerHeight = 80;
    }
    var titlesectionHeight = $('.post-title-filter-section').outerHeight();
    var totalHeight = headerHeight + footerHeight + titlesectionHeight;
    var windowHeight = $(window).innerHeight();
    var actualHeight = Number(windowHeight) - Number(totalHeight);
    $('.project-listing').css('min-height', actualHeight);
  }

  onWindowResize () {
    let that = this
    $( window ).resize(function() {
      that.bodySpacing()
    });
  }

}

export default projects


// WEBPACK FOOTER //
// ./src/js/shg/projects/projects.js